import React from 'react';

import useGlobalState from '../GlobalStateContext';

import { OptionalRolesOrPermissions } from 'crm/helpers/Permissions';

type Props = {
    callback: CallableFunction;
    title: string;
} & OptionalRolesOrPermissions;

export default function ButtonCallback({ callback, title, roles = [], permissions = [] }: Props) {
    const { loggedAdmin } = useGlobalState();

    return loggedAdmin.hasAccess(roles, permissions) ? (
        <button type="button" className="btn btn-primary btn-sm mb-3 mr-3" onClick={() => callback()}>
            {title}
        </button>
    ) : null;
}
